import { Text } from '@chakra-ui/react';
import { NumberInputPopover } from 'modules/common/components/ToolbarPopover';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { MAX_NR_ICONS, MIN_NR_ICONS, NR_OF_ICONS_DROPDOWN_OPTIONS } from '../IconWidget.config';

interface TotalItemsDropdownProps {
  numberOfIcons: number;
  onChange: (newNumberOfIcons: number) => void;
}

export const TotalItemsDropdown = ({ numberOfIcons, onChange }: TotalItemsDropdownProps): ReactElement => {
  const { t } = useTranslation('editor_widget_toolbar', {
    keyPrefix: 'statChartToolbar.totalItems',
    useSuspense: false,
  });

  const label = t('label');
  const numberInputId = 'total-items-dropdown';

  return (
    <>
      <Text as='label' whiteSpace='nowrap' fontSize='sm' htmlFor={numberInputId}>
        {label}
      </Text>
      <NumberInputPopover
        dropdownOptions={NR_OF_ICONS_DROPDOWN_OPTIONS}
        showInputStepper={false}
        value={numberOfIcons}
        // No tooltip required because there is a label
        label={''}
        min={MIN_NR_ICONS}
        max={MAX_NR_ICONS}
        onChange={onChange}
        inputId={numberInputId}
      />
    </>
  );
};
